/**
 * Root Imports
*/

import { ApiRequest } from '~/util/Api';

/**
 * Locals
*/

const endpoint = '/api/v1/users';

/**
 * Exports
*/

/**
 * 
 */
export function IndexUserService() {
  const config = {
    method: 'GET',
    uri: endpoint
  };

  return ApiRequest(config);
}

/**
 * 
 */
export function ShowUserService({ id }) {
  const config = {
    method: 'GET',
    uri: `${ endpoint }/${ id }`
  };

  return ApiRequest(config);
}

/**
 * 
 */
export function StoreUserService(data) {
  const config = {
    method: 'POST',
    uri: endpoint,
    data: data
  };

  return ApiRequest(config);
}

/**
 * 
 */
export function UpdateUserService({ id }, data) {
  const config = {
    method: 'PUT',
    uri: `${ endpoint }/${ id }`,
    data: data
  };

  return ApiRequest(config);
}